module.exports = __webpack_public_path__ + "static/media/abctract-wooden-texure-closeup-background.59f1297f.jpg";